import { useEffect, useState } from "react";
import { webUrlNode } from "../../../../../../constants/appInfo";
import axios from "axios";
import { useSelector } from "react-redux";

export default function BatchRow({homeworkId,batch,index,checked,linkedMap,setLinkedMap}){
  
  
    const AppToken = useSelector((s)=>s?.app?.app?.AppToken);
    const coursePostId = useSelector((s)=>s?.course?.course?.postId);
    const currentToken = useSelector((s)=>s?.user?.user?.token);
    const [releaseAt,setReleaseAt] = useState();
    const [dueAt,setDueAt] = useState();
    async function toggle(){

    const existingId = linkedMap[batch.batchId];

    try{
      
      // UNCHECK → DELETE
      if(existingId){
       
        await axios.delete(
          `${webUrlNode}/api/batches/homework/${existingId}?appToken=${AppToken}`
        );

        setLinkedMap(prev=>{
          const copy = {...prev};
          delete copy[batch.batchId];
          return copy;
        });

      }

      // CHECK → ATTACH
      else{

        const res = await axios.post(
          `${webUrlNode}/api/batches/${batch.batchId}/homework?appToken=${AppToken}`,
          {
            coursePostId,
            homeworkId,
            releaseAt:releaseAt,
            dueAt:dueAt,
            displayOrder:1
          }
        );

        const newId = res.data.id;

        setLinkedMap(prev => ({
          ...prev,
          [batch.batchId]: newId
        }));

      }

    }
    catch(e){
      alert("Failed to update batch link");
    }

  }

    async function loadBatchInfo(){

    const existingId = linkedMap[batch.batchId];

    try{
      
      // UNCHECK → DELETE
      if(existingId){
       
       const data = await axios.get(
            `${webUrlNode}/api/batches/${batch?.batchId}/homework?appToken=${AppToken}`
          )

          
        setDueAt(data?.data?.items[0]?.dueAt?data?.data?.items[0]?.dueAt.split("T")[0]:"")
        setReleaseAt(data?.data?.items[0]?.releaseAt?data?.data?.items[0]?.releaseAt.split("T")[0]:"")

      }

    }
    catch(e){
      
    }

  }
  useEffect(()=>{loadBatchInfo()},[])
  return(

    <div
     
      style={{
        background:"#f9f9f9",
        padding:"15px",
        borderRadius:6,
        marginBottom:10,
        display:"flex",
        justifyContent:"space-between",
        cursor:"pointer"
      }}
    >

      <div>

        <div style={{fontWeight:600}}>
          Batch {index+1}: {batch.batchName}
        </div>

        <div style={{fontSize:12,color:"#666"}}>
          {batch.mode} • {batch.enrollmentStatus}
        </div>
        <div style={{ display:"flex",
        justifyContent:"space-between", gap:"10px",flexWrap:"wrap"}}>
        <div style={{ display:"flex",
        justifyContent:"center", alignItems:"center",gap:"10px"}}>
      <div style={{fontSize:12,color:"#666"}}>    Release At: </div> 
 <input
          
          style={{fontSize:"20px",color:"#222222",background:"rgba(144, 202, 249,0.1)",border:"0px"
          ,borderRadius:"15px",cursor:"pointer",height:"35px"}}
            type="date"
            value={releaseAt}
            onChange={(e) => {setReleaseAt(e.target.value); }}
          />
          </div>
           <div style={{ display:"flex", justifyContent:"center", alignItems:"center",gap:"10px"}}>
          <div style={{fontSize:12,color:"#666"}}>Due At:</div> 
          <input
          
          style={{fontSize:"20px",color:"#222222",background:"rgba(144, 202, 249,0.1)",border:"0px"
          ,borderRadius:"15px",cursor:"pointer",height:"35px"}}
            type="date"
            value={dueAt}
            onChange={(e) => {setDueAt(e.target.value); }}
          />
</div></div>
      </div>

     
<label style={{marginTop:"30px"}} className={"checkbox-outer  "}>
        <input   className="input-textbox"
          type="checkbox"
           onClick={toggle}
        checked={checked}
        readOnly
       
        /> <span className={"square"}></span>

                                                                         </label>
    </div>

  )

}